<template>
	<div class="wrapperddiv">
	<el-card class="box-card">
		<div slot="header" class="clearfix">
			<span>今日特惠航线推荐</span>
		</div>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="海运整箱" name="first">
				<el-button type="primary" @click="addBtnFn">添加</el-button>
				<el-dialog title="新增" :visible.sync="addDialogVisible" width="95%" @close="addDialogClosed"
					:close-on-click-modal="false"
					:lock-scroll="false"
					>
					<el-form label-position="left" :rules="addFormRules" ref="addFormRef" :model="addForm"
						label-width="70px">
						<el-row :gutter="20">
							<el-col :span="6">
								<el-form-item label="起运港" prop="pol">
									<el-input v-model="addForm.pol" placeholder="请输入起运港"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="目的港" prop="pod">
									<el-input v-model="addForm.pod" placeholder="请输入目的港"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="船公司" prop="carrier">
									<el-input v-model="addForm.carrier" placeholder="请输入船公司"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="船期" prop="sale_state">
									<el-input v-model="addForm.sale_state" placeholder="请输入船期"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="6">
								<el-form-item label="20GP" prop="20GP">
									<el-input v-model="addForm['20GP']" placeholder="请输入20GP价格"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="40GP" prop="40GP">
									<el-input v-model="addForm['40GP']" placeholder="请输入40GP价格"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="40HQ" prop="40HQ">
									<el-input v-model="addForm['40HQ']" placeholder="请输入40GHQ价格"></el-input>
								</el-form-item>

							</el-col>
							<el-col :span="6">
								<el-form-item label="中转港" prop="via">
									<el-input v-model="addForm.via" placeholder="请输入中转港"></el-input>
								</el-form-item>
							</el-col>

						</el-row>
                          <el-row :gutter="20">
							  <el-col :span="6">
								  <el-form-item label="失效日" prop="valid_to">
								  	 <el-date-picker
								  	      v-model="addForm.valid_to"
								  	      type="datetime"
								  	      placeholder="选择日期时间"
								  	      default-time="00:00:00">
								  	    </el-date-picker>
								  </el-form-item>
								  </el-col>
                           </el-row>
					</el-form>

					<span slot="footer" class="dialog-footer">
						<el-button @click="addDialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="saveAddFclInfo">确 定</el-button>
					</span>
				</el-dialog>
<!-- 编辑对话框 -->
<el-dialog title="编辑" 
:visible.sync="editDialogVisible" 
width="95%" 
@close="editDialogClosed"
:lock-scroll="false"
:close-on-click-modal="false">
					<el-form label-position="left" :rules="editFormRules" ref="editFormRef" :model="editForm"
						label-width="70px">
						<el-row :gutter="20">
							<el-col :span="6">
								<el-form-item label="起运港" prop="pol">
									<el-input v-model="editForm.pol" placeholder="请输入起运港"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="目的港" prop="pod">
									<el-input v-model="editForm.pod" placeholder="请输入目的港"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="船公司" prop="carrier">
									<el-input v-model="editForm.carrier" placeholder="请输入船公司"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="船期" prop="sale_state">
									<el-input v-model="editForm.sale_state" placeholder="请输入船期"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20">
							<el-col :span="6">
								<el-form-item label="20GP" prop="20GP">
									<el-input v-model="editForm['20GP']" placeholder="请输入20GP价格"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="40GP" prop="40GP">
									<el-input v-model="editForm['40GP']" placeholder="请输入40GP价格"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item label="40HQ" prop="40HQ">
									<el-input v-model="editForm['40HQ']" placeholder="请输入40GHQ价格"></el-input>
								</el-form-item>

							</el-col>
							<el-col :span="6">
								<el-form-item label="中转港" prop="via">
									<el-input v-model="editForm.via" placeholder="请输入中转港"></el-input>
								</el-form-item>
							</el-col>

						</el-row>
                          <el-row :gutter="20">
							  <el-col :span="6">
								  <el-form-item label="失效日" prop="valid_to">
								  	 <el-date-picker
								  	      v-model="editForm.valid_to"
								  	      type="datetime"
								  	      placeholder="选择日期时间"
								  	      default-time="00:00:00">
								  	    </el-date-picker>
								  </el-form-item>
								  </el-col>
                           </el-row>
					</el-form>

					<span slot="footer" class="dialog-footer">
						<el-button @click="editDialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="editFclInfo">确 定</el-button>
					</span>
				</el-dialog>

				<div class="wrapper-fcl">
					<div class="wrapper-fcl-item"></div>
					<span>预览</span>
				</div>
				<div class="ysbj">
					<div style="display: flex;flex-wrap: wrap;" v-if="tjFclList.length>0">
						<div style="padding-top: 30px;padding: 15px;" v-for="item in tjFclList" :key="item.id">
							<el-card class="box-card-list" shadow="always">
								<el-row type="flex" justify="end" style="margin-top: -15px;margin-bottom: 5px;">
									<i class="iconfont icon-bianji" style="margin-right: 10px;" @click="editFclCard(item.id)"></i>
									<i class="iconfont icon-guanbi" @click="deteleFclCard(item.id)"></i>
								</el-row>

								<div style="display: flex;">
									<span>{{item.pol}}</span>
									<i class="iconfont icon-jiantou"></i>
									<span>{{item.pod}}</span>
								</div>
								<div style="padding-top: 10px;color: #FF0000;font-weight: bold;">
									<span>{{`${'$' + item['20GP'] + ' /'+'$' + item['40GP']+ ' /' +'$'+ item['40HQ']}`}}</span>
								</div>
								<div style="padding-top: 10px;display: flex;justify-content: space-between;">
									<span>船期:{{item.sale_state}}</span>
									<span>船公司:{{item.carrier}}</span>
								</div>
								<div style="padding-top: 10px;display: flex;justify-content: space-between;">
									<span>中转港:{{item.via}}</span>
									<span>失效日:{{item.valid_to}}</span>
								</div>
							</el-card>
						</div>
					</div>
					<div v-else><el-empty description="当前没有特惠航线"></el-empty></div>

				</div>

			</el-tab-pane>
			<el-tab-pane label="海运拼箱" name="second">
				<el-button type="primary" @click="addLclBtnFn">添加</el-button>
								<el-dialog title="新增" 
								:lock-scroll="false"
								:visible.sync="addLclDialogVisible" width="95%" @close="addLclDialogClosed"
									:close-on-click-modal="false">
									<el-form label-position="left" :rules="addLclFormRules" ref="addLclFormRef" :model="addLclForm"
										label-width="70px">
										<el-row :gutter="20">
											<el-col :span="6">
												<el-form-item label="起运港" prop="pol">
													<el-input v-model="addLclForm.pol" placeholder="请输入起运港"></el-input>
												</el-form-item>
											</el-col>
											<el-col :span="6">
												<el-form-item label="目的港" prop="pod">
													<el-input v-model="addLclForm.pod" placeholder="请输入目的港"></el-input>
												</el-form-item>
											</el-col>
											<el-col :span="6">
												<el-form-item label="国家" prop="country">
													<el-input v-model="addLclForm.country" placeholder="请输入国家"></el-input>
												</el-form-item>
											</el-col>
											<el-col :span="6">
												<el-form-item label="中转港" prop="via">
													<el-input v-model="addLclForm.via" placeholder="请输入中转港"></el-input>
												</el-form-item>
											</el-col>
										</el-row>
										<el-row :gutter="20">
											<el-col :span="6">
											<el-form-item label="货量" prop="volume">
												<el-input v-model="addLclForm.volume" placeholder="请输入货量"></el-input>
											</el-form-item>
											</el-col>
											<el-col :span="6">
											<el-form-item label="体积价" prop="freight_cmb">
												<el-input v-model="addLclForm.freight_cmb" placeholder="请输入体积价"></el-input>
											</el-form-item>
											</el-col>
			                                <el-col :span="6">
			                                <el-form-item label="重量价" prop="freight_ton">
			                                	<el-input v-model="addLclForm.freight_ton" placeholder="请输入重量价"></el-input>
			                                </el-form-item>
			                                </el-col>
											<el-col :span="6">
											<el-form-item label="航程" prop="t_t">
												<el-input v-model="addLclForm.t_t" placeholder="请输入预计航程"></el-input>
											</el-form-item>
											</el-col>
											
										</el-row>
				                          <el-row :gutter="20">
											  <el-col :span="6">
											  <el-form-item label="开航日" prop="etd">
											  	<el-input v-model="addLclForm.etd" placeholder="请输入开航日"></el-input>
											  </el-form-item>
											  </el-col>
											  <el-col :span="6">
												  <el-form-item label="失效日" prop="valid_to">
												  	 <el-date-picker
												  	      v-model="addLclForm.valid_to"
												  	      type="datetime"
												  	      placeholder="选择日期时间"
												  	      default-time="00:00:00">
												  	    </el-date-picker>
												  </el-form-item>
												  </el-col>
				                           </el-row>
									</el-form>
				
									<span slot="footer" class="dialog-footer">
										<el-button @click="addLclDialogVisible = false">取 消</el-button>
										<el-button type="primary" @click="saveAddLclInfo">确 定</el-button>
									</span>
								</el-dialog>
				<!-- 编辑对话框 -->
				<el-dialog title="编辑" 
				:visible.sync="editLclDialogVisible" 
				width="95%" 
				:lock-scroll="false"
				@close="editLclDialogClosed"
				:close-on-click-modal="false">
									<el-form label-position="left" 
									:rules="editLclFormRules" 
									ref="editLclFormRef" 
									:model="editLclForm"
										label-width="70px">
										<el-row :gutter="20">
											<el-col :span="6">
												<el-form-item label="起运港" prop="pol">
													<el-input v-model="editLclForm.pol" placeholder="请输入起运港"></el-input>
												</el-form-item>
											</el-col>
											<el-col :span="6">
												<el-form-item label="目的港" prop="pod">
													<el-input v-model="editLclForm.pod" placeholder="请输入目的港"></el-input>
												</el-form-item>
											</el-col>
											<el-col :span="6">
												<el-form-item label="国家" prop="country">
													<el-input v-model="editLclForm.country" placeholder="请输入国家"></el-input>
												</el-form-item>
											</el-col>
											<el-col :span="6">
												<el-form-item label="中转港" prop="via">
													<el-input v-model="editLclForm.via" placeholder="请输入中转港"></el-input>
												</el-form-item>
											</el-col>
										</el-row>
										<el-row :gutter="20">
											<el-col :span="6">
											<el-form-item label="货量" prop="volume">
												<el-input v-model="editLclForm.volume" placeholder="请输入货量"></el-input>
											</el-form-item>
											</el-col>
											<el-col :span="6">
											<el-form-item label="体积价" prop="freight_cmb">
												<el-input v-model="editLclForm.freight_cmb" placeholder="请输入体积价"></el-input>
											</el-form-item>
											</el-col>
										    <el-col :span="6">
										    <el-form-item label="重量价" prop="freight_ton">
										    	<el-input v-model="editLclForm.freight_ton" placeholder="请输入重量价"></el-input>
										    </el-form-item>
										    </el-col>
											<el-col :span="6">
											<el-form-item label="航程" prop="t_t">
												<el-input v-model="editLclForm.t_t" placeholder="请输入预计航程"></el-input>
											</el-form-item>
											</el-col>
											
										</el-row>
										  <el-row :gutter="20">
											  <el-col :span="6">
											  <el-form-item label="开航日" prop="etd">
											  	<el-input v-model="editLclForm.etd" placeholder="请输入开航日"></el-input>
											  </el-form-item>
											  </el-col>
											  <el-col :span="6">
												  <el-form-item label="失效日" prop="valid_to">
												  	 <el-date-picker
												  	      v-model="editLclForm.valid_to"
												  	      type="datetime"
												  	      placeholder="选择日期时间"
												  	      default-time="00:00:00">
												  	    </el-date-picker>
												  </el-form-item>
												  </el-col>
										   </el-row>
									</el-form>
				
									<span slot="footer" class="dialog-footer">
										<el-button @click="editLclDialogVisible = false">取 消</el-button>
										<el-button type="primary" @click="editLclInfo">确 定</el-button>
									</span>
								</el-dialog>
				
								<div class="wrapper-fcl">
									<div class="wrapper-fcl-item"></div>
									<span>预览</span>
								</div>
								<div class="ysbj">
									<div style="display: flex;flex-wrap: wrap;" v-if="tjLclList.length>0">
										<div style="padding-top: 30px;padding: 15px;" v-for="item in tjLclList" :key="item.id">
											<el-card class="box-card-list" shadow="always">
												<el-row type="flex" justify="end" style="margin-top: -15px;margin-bottom: 5px;">
													<i class="iconfont icon-bianji" style="margin-right: 10px;" @click="editLclCard(item.id)"></i>
													<i class="iconfont icon-guanbi" @click="deteleLclCard(item.id)"></i>
												</el-row>
				
												<div style="display: flex;">
													<span>{{item.pol}}</span>
													<i class="iconfont icon-jiantou"></i>
													<span>{{item.pod}}</span>
												</div>
												<div style="padding-top: 10px;display: flex;justify-content: space-between;">
												   <div style="color: #FF0000;font-weight: bold;">
													<!-- <span>{{`${'$' + item['freight_cmb'] + ' /'+'$' + item['freight_ton']}`}}</span> -->
													<span>{{item['volume']}} / CMB:{{`${'$' + item['freight_cmb']}`}} / TON:{{`${'$' + item['freight_ton']}`}}</span>
													</div>
													<span>国家:{{item.country}}</span>
												</div>
												<div style="padding-top: 10px;display: flex;justify-content: space-between;">
													<span>预计航程:{{item.t_t}}</span>
													<span>开航日:{{item.etd}}</span>
												</div>
												<div style="padding-top: 10px;display: flex;justify-content: space-between;">
													<span>中转港:{{item.via}}</span>
													<span>失效日:{{item.valid_to}}</span>
												</div>
											</el-card>
										</div>
									</div>
									<div v-else><el-empty description="当前没有特惠航线"></el-empty></div>
				
								</div>
			</el-tab-pane>
			<el-tab-pane label="空运" name="third">
			<el-button type="primary" @click="addByAirBtnFn">添加</el-button>
							<el-dialog title="新增" 
							:lock-scroll="false"
							:visible.sync="addByAirDialogVisible" width="95%" @close="addByAirDialogClosed"
								:close-on-click-modal="false">
								<el-form label-position="left" :rules="addByAirFormRules" ref="addByAirFormRef" :model="addByAirForm"
									label-width="80px">
									<el-row :gutter="20">
										<el-col :span="6">
											<el-form-item label="起运港" prop="pol">
												<el-input v-model="addByAirForm.pol" placeholder="请输入起运港"></el-input>
											</el-form-item>
										</el-col>
										<el-col :span="6">
											<el-form-item label="目的港" prop="pod">
												<el-input v-model="addByAirForm.pod" placeholder="请输入目的港"></el-input>
											</el-form-item>
										</el-col>
										<el-col :span="6">
											<el-form-item label="国家" prop="country">
												<el-input v-model="addByAirForm.country" placeholder="请输入国家"></el-input>
											</el-form-item>
										</el-col>
										<el-col :span="6">
											<el-form-item label="航班日期" prop="etd">
												<el-input v-model="addByAirForm.etd" placeholder="请输入航班日期"></el-input>
											</el-form-item>
										</el-col>
										
									</el-row>
			                          <el-row :gutter="20">
										  <el-col :span="6">
										  	<el-form-item label="航空公司" prop="carrier">
										  		<el-input v-model="addByAirForm.carrier" placeholder="请输入航空公司"></el-input>
										  	</el-form-item>
										  </el-col>
										  <el-col :span="6">
										  	<el-form-item label="中转港" prop="via">
									  		<el-input v-model="addByAirForm.via" placeholder="请输入中转港"></el-input>
										  	</el-form-item>
										  </el-col>
										  <el-col :span="6">
										  	<el-form-item label="预计时效" prop="t_t">
										  		<el-input v-model="addByAirForm['t_t']" placeholder="请输入预计时效"></el-input>
										  	</el-form-item>
										  </el-col>
										  <el-col :span="6">
											  <el-form-item label="失效日" prop="valid_fm">
											  	 <el-date-picker
											  	      v-model="addByAirForm.valid_fm"
											  	      type="datetime"
											  	      placeholder="选择日期时间"
											  	      default-time="00:00:00">
											  	    </el-date-picker>
											  </el-form-item>
											  </el-col>
			                           </el-row>
								</el-form>
			
								<span slot="footer" class="dialog-footer">
									<el-button @click="addByAirDialogVisible = false">取 消</el-button>
									<el-button type="primary" @click="saveAddByAirInfo">确 定</el-button>
								</span>
							</el-dialog>
			<!-- 编辑对话框 -->
			<el-dialog title="编辑" 
			:visible.sync="editByAirDialogVisible" 
			width="95%" 
			:lock-scroll="false"
			@close="editByAirDialogClosed"
			:close-on-click-modal="false">
								<el-form label-position="left" 
								:rules="editByAirFormRules" 
								ref="editByAirFormRef" 
								:model="editByAirForm"
									label-width="80px">
								
							
			                <el-row :gutter="20">
			                	<el-col :span="6">
			                		<el-form-item label="起运港" prop="pol">
			                			<el-input v-model="editByAirForm.pol" placeholder="请输入起运港"></el-input>
			                		</el-form-item>
			                	</el-col>
			                	<el-col :span="6">
			                		<el-form-item label="目的港" prop="pod">
			                			<el-input v-model="editByAirForm.pod" placeholder="请输入目的港"></el-input>
			                		</el-form-item>
			                	</el-col>
			                	<el-col :span="6">
			                		<el-form-item label="国家" prop="country">
			                			<el-input v-model="editByAirForm.country" placeholder="请输入国家"></el-input>
			                		</el-form-item>
			                	</el-col>
			                	<el-col :span="6">
			                		<el-form-item label="航班日期" prop="etd">
			                			<el-input v-model="editByAirForm.etd" placeholder="请输入航班日期"></el-input>
			                		</el-form-item>
			                	</el-col>
			                	
			                </el-row>
			                  <el-row :gutter="20">
			                	  <el-col :span="6">
			                	  	<el-form-item label="航空公司" prop="carrier">
			                	  		<el-input v-model="editByAirForm.carrier" placeholder="请输入航空公司"></el-input>
			                	  	</el-form-item>
			                	  </el-col>
			                	  <el-col :span="6">
			                	  	<el-form-item label="中转港" prop="via">
			                  		<el-input v-model="editByAirForm.via" placeholder="请输入中转港"></el-input>
			                	  	</el-form-item>
			                	  </el-col>
			                	  <el-col :span="6">
			                	  	<el-form-item label="预计时效" prop="t_t">
			                	  		<el-input v-model="editByAirForm['t_t']" placeholder="请输入预计时效"></el-input>
			                	  	</el-form-item>
			                	  </el-col>
			                	  <el-col :span="6">
			                		  <el-form-item label="失效日" prop="valid_fm">
			                		  	 <el-date-picker
			                		  	      v-model="editByAirForm.valid_fm"
			                		  	      type="datetime"
			                		  	      placeholder="选择日期时间"
			                		  	      default-time="00:00:00">
			                		  	    </el-date-picker>
			                		  </el-form-item>
			                		  </el-col>
			                   </el-row>
								  	</el-form>
								<span slot="footer" class="dialog-footer">
									<el-button @click="editByAirDialogVisible = false">取 消</el-button>
									<el-button type="primary" @click="editByAirInfo">确 定</el-button>
								</span>
							</el-dialog>
			
							<div class="wrapper-fcl">
								<div class="wrapper-fcl-item"></div>
								<span>预览</span>
							</div>
							<div class="ysbj">
								<div style="display: flex;flex-wrap: wrap;" v-if="tjByAirList.length>0">
									<div style="padding-top: 30px;padding: 15px;" v-for="item in tjByAirList" :key="item.id">
										<el-card class="box-card-list" shadow="always">
											<el-row type="flex" justify="end" style="margin-top: -15px;margin-bottom: 5px;">
												<i class="iconfont icon-bianji" style="margin-right: 10px;" 
												@click="editByAirCard(item.id)"></i>
												<i class="iconfont icon-guanbi" @click="deteleByAirCard(item.id)"></i>
											</el-row>
			                               
											<div style="display: flex;color: blue;">
												<span>{{item.pol}}</span>
												<i class="iconfont icon-jiantou"></i>
												<span>{{item.pod}}</span>
											</div>
											<div style="padding-top: 10px;display: flex;justify-content: space-between;">
												<span>国家:{{item.country}}</span>
												<span>预计时效:{{item.t_t}}</span>
											</div>
											<div style="padding-top: 10px;display: flex;justify-content: space-between;">
												<span>航空公司:{{item.carrier}}</span>
												<span>航班日期:{{item.etd}}</span>
											</div>
											<div style="padding-top: 10px;display: flex;justify-content: space-between;">
												<span>中转港:{{item.via}}</span>
												<span>失效日:{{item.valid_fm}}</span>
											</div>
											     
										</el-card>
									</div>
								</div>
								<div v-else><el-empty description="当前没有特惠航线"></el-empty></div>
			
							</div>
				
				
				
			</el-tab-pane>
			<el-tab-pane label="铁路" name="four">
		
							<el-button type="primary" @click="addrailroadBtnFn">添加</el-button>
							<el-dialog title="新增" :visible.sync="addrailroadDialogVisible" width="95%" @close="addrailroadDialogClosed"
								:close-on-click-modal="false"
								:lock-scroll="false"
								>
								<el-form 
								label-position="left" 
								:rules="addrailroadFormRules" ref="addrailroadFormRef" :model="addrailroadForm"
									label-width="90px">
									<el-row :gutter="20">
										<el-col :span="6">
											<el-form-item label="起运港" prop="pol">
												<el-input v-model="addrailroadForm.pol" placeholder="请输入起运港"></el-input>
											</el-form-item>
										</el-col>
										<el-col :span="6">
											<el-form-item label="目的港" prop="pod">
												<el-input v-model="addrailroadForm.pod" placeholder="请输入目的港"></el-input>
											</el-form-item>
										</el-col>
									<el-col :span="6">
										<el-form-item label="40coc" prop="40_coc">
											<el-input v-model="addrailroadForm['40_coc']" placeholder="请输入40coc价格"></el-input>
										</el-form-item>
									</el-col>
									<el-col :span="6">
										<el-form-item label="40soc" prop="40_soc">
											<el-input v-model="addrailroadForm['40_soc']" placeholder="请输入40soc价格"></el-input>
										</el-form-item>
									</el-col>
									</el-row>
									<el-row :gutter="20">
										<el-col :span="6">
											<el-form-item label="20coc" prop="20_coc">
												<el-input v-model="addrailroadForm['20_coc']" placeholder="请输入20coc价格"></el-input>
											</el-form-item>
										</el-col>
										<el-col :span="6">
											<el-form-item label="20soc" prop="20_soc">
												<el-input v-model="addrailroadForm['20_soc']" placeholder="请输入20soc价格"></el-input>
											</el-form-item>
										</el-col>
										<el-col :span="6">
											<el-form-item label="2*20soc" prop="2_20soc">
												<el-input v-model="addrailroadForm['2_20soc']" placeholder="请输入2*20soc价格"></el-input>
											</el-form-item>
			
										</el-col>
			<el-col :span="6">
				<el-form-item label="币种" prop="currency">
					<el-input v-model="addrailroadForm['currency']" placeholder="请输入币种"></el-input>
				</el-form-item>
						
			</el-col>
			
									</el-row>
			                          <el-row :gutter="20">
										  <el-col :span="6">
										  	<el-form-item label="班列" prop="squad">
										  		<el-input v-model="addrailroadForm['squad']" placeholder="请输入班列"></el-input>
										  	</el-form-item>
										  			
										  </el-col>
										  <el-col :span="6">
										  	<el-form-item label="预计航程" prop="t_t">
										  		<el-input v-model="addrailroadForm['t_t']" placeholder="请输入预计航程"></el-input>
										  	</el-form-item>
										  			
										  </el-col>
										  <el-col :span="6">
											  <el-form-item label="失效日" prop="valid_to">
											  	 <el-date-picker
											  	      v-model="addrailroadForm.valid_to"
											  	      type="datetime"
											  	      placeholder="选择日期时间"
											  	      default-time="00:00:00">
											  	    </el-date-picker>
											  </el-form-item>
											  </el-col>
			                           </el-row>
								</el-form>
			
								<span slot="footer" class="dialog-footer">
									<el-button @click="addrailroadDialogVisible = false">取 消</el-button>
									<el-button type="primary" @click="saveAddrailroadInfo">确 定</el-button>
								</span>
							</el-dialog>
			<!-- 编辑对话框 -->
			<el-dialog title="编辑" 
			:visible.sync="editrailroadDialogVisible" 
			width="95%" 
			@close="editrailroadDialogClosed"
			:lock-scroll="false"
			:close-on-click-modal="false">
								<el-form label-position="left" :rules="editrailroadFormRules" ref="editrailroadFormRef" :model="editrailroadForm"
									label-width="100px">
									<el-row :gutter="20">
																<el-col :span="6">
																	<el-form-item label="起运港" prop="pol">
																		<el-input v-model="editrailroadForm.pol" placeholder="请输入起运港"></el-input>
																	</el-form-item>
																</el-col>
																<el-col :span="6">
																	<el-form-item label="目的港" prop="pod">
																		<el-input v-model="editrailroadForm.pod" placeholder="请输入目的港"></el-input>
																	</el-form-item>
																</el-col>
															<el-col :span="6">
																<el-form-item label="40coc" prop="40_coc">
																	<el-input v-model="editrailroadForm['40_coc']" placeholder="请输入40coc价格"></el-input>
																</el-form-item>
															</el-col>
															<el-col :span="6">
																<el-form-item label="40soc" prop="40_soc">
																	<el-input v-model="editrailroadForm['40_soc']" placeholder="请输入40soc价格"></el-input>
																</el-form-item>
															</el-col>
															</el-row>
															<el-row :gutter="20">
																<el-col :span="6">
																	<el-form-item label="20coc" prop="20_coc">
																		<el-input v-model="editrailroadForm['20_coc']" placeholder="请输入20coc价格"></el-input>
																	</el-form-item>
																</el-col>
																<el-col :span="6">
																	<el-form-item label="20soc" prop="20_soc">
																		<el-input v-model="editrailroadForm['20_soc']" placeholder="请输入20soc价格"></el-input>
																	</el-form-item>
																</el-col>
																<el-col :span="6">
																	<el-form-item label="2*20soc" prop="2_20soc">
																		<el-input v-model="editrailroadForm['2_20soc']" placeholder="请输入2*20soc价格"></el-input>
																	</el-form-item>
									
																</el-col>
									<el-col :span="6">
										<el-form-item label="币种" prop="currency">
											<el-input v-model="editrailroadForm['currency']" placeholder="请输入币种"></el-input>
										</el-form-item>
												
									</el-col>
									
															</el-row>
									                          <el-row :gutter="20">
																  <el-col :span="6">
																  	<el-form-item label="班列" prop="squad">
																  		<el-input v-model="editrailroadForm['squad']" placeholder="请输入班列"></el-input>
																  	</el-form-item>
																  			
																  </el-col>
																  <el-col :span="6">
																  	<el-form-item label="预计航程" prop="t_t">
																  		<el-input v-model="editrailroadForm['t_t']" placeholder="请输入预计航程"></el-input>
																  	</el-form-item>
																  			
																  </el-col>
																  <el-col :span="6">
																	  <el-form-item label="失效日" prop="valid_to">
																	  	 <el-date-picker
																	  	      v-model="editrailroadForm.valid_to"
																	  	      type="datetime"
																	  	      placeholder="选择日期时间"
																	  	      default-time="00:00:00">
																	  	    </el-date-picker>
																	  </el-form-item>
																	  </el-col>
									                           </el-row>
								</el-form>
			
								<span slot="footer" class="dialog-footer">
									<el-button @click="editrailroadDialogVisible = false">取 消</el-button>
									<el-button type="primary" @click="editrailroadInfo">确 定</el-button>
								</span>
							</el-dialog>
			
							<div class="wrapper-fcl">
								<div class="wrapper-fcl-item"></div>
								<span>预览</span>
							</div>
							<div class="ysbj">
								<div style="display: flex;flex-wrap: wrap;" v-if="tjrailroadList.length>0">
									<div style="padding-top: 30px;padding: 15px;" v-for="item in tjrailroadList" :key="item.id">
										<el-card class="box-card-list" shadow="always">
											<el-row type="flex" justify="end" style="margin-top: -15px;margin-bottom: 5px;">
												<i class="iconfont icon-bianji" style="margin-right: 10px;" @click="editRailroadCard(item.id)"></i>
												<i class="iconfont icon-guanbi" @click="deteleRailroadCard(item.id)"></i>
											</el-row>
			
											<div style="display: flex;">
												<span>{{item.pol}}</span>
												<i class="iconfont icon-jiantou"></i>
												<span>{{item.pod}}</span>
											</div>
											<div style="padding-top: 10px;color: #FF0000;font-weight: bold;">
			<span>{{`${'$' + item['40_coc'] + ' /'+'$' + item['40_soc']+ ' /' +'$'+ item['20_coc'] + ' /' +'$'+ item['20_soc'] + ' /' +'$'+ item['2_20soc']}`}}</span>
											</div>
											<div style="padding-top: 10px;display: flex;justify-content: space-between;">
												<span>币种:{{item.currency}}</span>
												<span>班列:{{item.squad}}</span>
											</div>
											<div style="padding-top: 10px;display: flex;justify-content: space-between;">
												<span>预计航程:{{item.t_t}}</span>
												<span>失效日:{{item.valid_to}}</span>
											</div>
										</el-card>
									</div>
								</div>
								<div v-else><el-empty description="当前没有特惠航线"></el-empty></div>
			
							</div>
	
			</el-tab-pane>
			
			
			
			
			<el-tab-pane label="内陆拖车" name="five">
				<el-button type="primary" @click="addTrailerBtnFn">添加</el-button>
								<el-dialog title="新增" 
								:lock-scroll="false"
								:visible.sync="addTrailerDialogVisible" width="95%" @close="addTrailerDialogClosed"
									:close-on-click-modal="false">
									<el-form label-position="left" :rules="addTrailerFormRules" ref="addTrailerFormRef" :model="addTrailerForm"
										label-width="80px">
										<el-row :gutter="20">
											<el-col :span="6">
												<el-form-item label="港区" prop="dock">
													<el-input v-model="addTrailerForm.dock" placeholder="请输入港区"></el-input>
												</el-form-item>
											</el-col>
											<el-col :span="6">
												<el-form-item label="门点地址" prop="trailer_door_point">
													<el-input v-model="addTrailerForm.trailer_door_point" placeholder="请输入门点地址"></el-input>
												</el-form-item>
											</el-col>
											<el-col :span="6">
												<el-form-item label="20GP" prop="20GP">
													<el-input v-model="addTrailerForm['20GP']" placeholder="请输入价格"></el-input>
												</el-form-item>
											</el-col>
											<el-col :span="6">
												<el-form-item label="40GP" prop="40GP">
													<el-input v-model="addTrailerForm['40GP']" placeholder="请输入价格"></el-input>
												</el-form-item>
											</el-col>
											
										</el-row>
				                          <el-row :gutter="20">
											  <el-col :span="6">
											  	<el-form-item label="40HQ" prop="40HQ">
											  		<el-input v-model="addTrailerForm['40HQ']" placeholder="请输入价格"></el-input>
											  	</el-form-item>
											  </el-col>
											  <el-col :span="6">
												  <el-form-item label="失效日" prop="valid_to">
												  	 <el-date-picker
												  	      v-model="addTrailerForm.valid_to"
												  	      type="datetime"
												  	      placeholder="选择日期时间"
												  	      default-time="00:00:00">
												  	    </el-date-picker>
												  </el-form-item>
												  </el-col>
				                           </el-row>
									</el-form>
				
									<span slot="footer" class="dialog-footer">
										<el-button @click="addTrailerDialogVisible = false">取 消</el-button>
										<el-button type="primary" @click="saveAddTrailerInfo">确 定</el-button>
									</span>
								</el-dialog>
				<!-- 编辑对话框 -->
				<el-dialog title="编辑" 
				:visible.sync="editTrailerDialogVisible" 
				width="95%" 
				:lock-scroll="false"
				@close="editTrailerDialogClosed"
				:close-on-click-modal="false">
									<el-form label-position="left" 
									:rules="editTrailerFormRules" 
									ref="editTrailerFormRef" 
									:model="editTrailerForm"
										label-width="80px">
									
								
				                   <el-row :gutter="20">
				                   	<el-col :span="6">
				                   		<el-form-item label="港区" prop="dock">
				                   			<el-input v-model="editTrailerForm.dock" placeholder="请输入港区"></el-input>
				                   		</el-form-item>
				                   	</el-col>
				                   	<el-col :span="6">
				                   		<el-form-item label="门点地址" prop="trailer_door_point">
				                   			<el-input v-model="editTrailerForm.trailer_door_point" placeholder="请输入门点地址"></el-input>
				                   		</el-form-item>
				                   	</el-col>
				                   	<el-col :span="6">
				                   		<el-form-item label="20GP" prop="20GP">
				                   			<el-input v-model="editTrailerForm['20GP']" placeholder="请输入价格"></el-input>
				                   		</el-form-item>
				                   	</el-col>
				                   	<el-col :span="6">
				                   		<el-form-item label="40GP" prop="40GP">
				                   			<el-input v-model="editTrailerForm['40GP']" placeholder="请输入价格"></el-input>
				                   		</el-form-item>
				                   	</el-col>
				                   	
				                   </el-row>
				                     <el-row :gutter="20">
				                   	  <el-col :span="6">
				                   	  	<el-form-item label="40HQ" prop="40HQ">
				                   	  		<el-input v-model="editTrailerForm['40HQ']" placeholder="请输入价格"></el-input>
				                   	  	</el-form-item>
				                   	  </el-col>
				                   	  <el-col :span="6">
				                   		  <el-form-item label="失效日" prop="valid_to">
				                   		  	 <el-date-picker
				                   		  	      v-model="editTrailerForm.valid_to"
				                   		  	      type="datetime"
				                   		  	      placeholder="选择日期时间"
				                   		  	      default-time="00:00:00">
				                   		  	    </el-date-picker>
				                   		  </el-form-item>
				                   		  </el-col>
				                      </el-row>
									  	</el-form>
									<span slot="footer" class="dialog-footer">
										<el-button @click="editTrailerDialogVisible = false">取 消</el-button>
										<el-button type="primary" @click="editTrailerInfo">确 定</el-button>
									</span>
								</el-dialog>
				
								<div class="wrapper-fcl">
									<div class="wrapper-fcl-item"></div>
									<span>预览</span>
								</div>
								<div class="ysbj">
									<div style="display: flex;flex-wrap: wrap;" v-if="tjTrailerList.length>0">
										<div style="padding-top: 30px;padding: 15px;" v-for="item in tjTrailerList" :key="item.id">
											<el-card class="box-card-list" shadow="always">
												<el-row type="flex" justify="end" style="margin-top: -15px;margin-bottom: 5px;">
													<i class="iconfont icon-bianji" style="margin-right: 10px;" 
													@click="editTrailerCard(item.id)"></i>
													<i class="iconfont icon-guanbi" @click="deteleTrailerCard(item.id)"></i>
												</el-row>
				                                 <div style="padding: 30px 0 30px 0;">
												<div style="display: flex;">
													<span>{{item.dock}}</span>
													<i class="iconfont icon-jiantou"></i>
													<span>{{item.trailer_door_point}}</span>
												</div>
												<div style="padding-top: 10px;display: flex;justify-content: space-between;">
												   <div style="color: #FF0000;font-weight: bold;">
													<span>{{`${'￥' + item['20GP'] + ' /'+'￥' + item['40GP'] + ' /' +'￥'+ item['40HQ']}`}}</span>
													</div>
													<span>失效日:{{item.valid_to}}</span>
												</div>
												      </div>
											</el-card>
										</div>
									</div>
									<div v-else><el-empty description="当前没有特惠航线"></el-empty></div>
				
								</div>
				
				
			</el-tab-pane>
			
			
			
			<el-tab-pane label="国际快递" name="six">
				<el-button type="primary" @click="addExpressBtnFn">添加</el-button>
								<el-dialog title="新增" 
								:lock-scroll="false"
								:visible.sync="addExpressDialogVisible" 
								width="95%" 
								@close="addExpressDialogClosed"
									:close-on-click-modal="false">
									<el-form label-position="left" 
									:rules="addExpressFormRules" 
									ref="addExpressFormRef" 
									:model="addExpressForm"
										label-width="80px">
										<el-row :gutter="20">
											<el-col :span="6">
												<el-form-item label="起始地" prop="from">
													<el-input v-model="addExpressForm.from" placeholder="请输入起始地"></el-input>
												</el-form-item>
											</el-col>
											<el-col :span="6">
												<el-form-item label="目的地" prop="to">
													<el-input v-model="addExpressForm.to" placeholder="请输入目的地"></el-input>
												</el-form-item>
											</el-col>
											<el-col :span="6">
												<el-form-item label="重量" prop="weight">
													<el-input v-model="addExpressForm.weight" placeholder="请输入重量"></el-input>
												</el-form-item>
											</el-col>
											<el-col :span="6">
												<el-form-item label="标准价格" prop="special_cost">
													<el-input v-model="addExpressForm.special_cost" placeholder="请输入标准价格"></el-input>
												</el-form-item>
											</el-col>
											
										</el-row>
				                          <el-row :gutter="20">
											  <el-col :span="6">
											  	<el-form-item label="燃油费" prop="fuel">
											  		<el-input v-model="addExpressForm.fuel" placeholder="请输入燃油费"></el-input>
											  	</el-form-item>
											  </el-col>
											  <el-col :span="6">
											  	<el-form-item label="折扣" prop="discount">
											  		<el-input v-model="addExpressForm.discount" placeholder="请输入折扣"></el-input>
											  	</el-form-item>
											  </el-col>
											  <el-col :span="6">
											  	<el-form-item label="总费用" prop="total_cost">
											  		<el-input v-model="addExpressForm.total_cost" placeholder="请输入总费用"></el-input>
											  	</el-form-item>
											  </el-col>
											  <el-col :span="6">
												  <el-form-item label="失效日" prop="valid_to">
												  	 <el-date-picker
												  	      v-model="addExpressForm.valid_to"
												  	      type="datetime"
												  	      placeholder="选择日期时间"
												  	      default-time="00:00:00">
												  	    </el-date-picker>
												  </el-form-item>
												  </el-col>
				                           </el-row>
										   <el-row :gutter="20">
										    <el-col :span="6">
										    	<el-form-item label="网络类型" prop="cate">
										    		<el-input v-model="addExpressForm.cate" placeholder="请输入网络类型"></el-input>
										    	</el-form-item>
										    </el-col>
										   								
										   									
										    </el-row>
									</el-form>
				
									<span slot="footer" class="dialog-footer">
										<el-button @click="addExpressDialogVisible = false">取 消</el-button>
										<el-button type="primary" @click="saveAddExpressInfo">确 定</el-button>
									</span>
								</el-dialog>
				<!-- 编辑对话框 -->
				<el-dialog title="编辑" 
				:visible.sync="editExpressDialogVisible" 
				width="95%" 
				:lock-scroll="false"
				@close="editExpressDialogClosed"
				:close-on-click-modal="false">
									<el-form label-position="left" 
									:rules="editExpressFormRules" 
									ref="editExpressFormRef" 
									:model="editExpressForm"
									label-width="80px">
									
								
				                   <el-row :gutter="20">
				                   	<el-col :span="6">
				                   		<el-form-item label="起始地" prop="from">
				                   			<el-input v-model="editExpressForm.from" placeholder="请输入起始地"></el-input>
				                   		</el-form-item>
				                   	</el-col>
				                   	<el-col :span="6">
				                   		<el-form-item label="目的地" prop="to">
				                   			<el-input v-model="editExpressForm.to" placeholder="请输入目的地"></el-input>
				                   		</el-form-item>
				                   	</el-col>
				                   	<el-col :span="6">
				                   		<el-form-item label="重量" prop="weight">
				                   			<el-input v-model="editExpressForm.weight" placeholder="请输入重量"></el-input>
				                   		</el-form-item>
				                   	</el-col>
				                   	<el-col :span="6">
				                   		<el-form-item label="标准价格" prop="special_cost">
				                   			<el-input v-model="editExpressForm.special_cost" placeholder="请输入标准价格"></el-input>
				                   		</el-form-item>
				                   	</el-col>
				                   	
				                   </el-row>
				                     <el-row :gutter="20">
				                   	  <el-col :span="6">
				                   	  	<el-form-item label="燃油费" prop="fuel">
				                   	  		<el-input v-model="editExpressForm.fuel" placeholder="请输入燃油费"></el-input>
				                   	  	</el-form-item>
				                   	  </el-col>
				                   	  <el-col :span="6">
				                   	  	<el-form-item label="折扣" prop="discount">
				                   	  		<el-input v-model="editExpressForm.discount" placeholder="请输入折扣"></el-input>
				                   	  	</el-form-item>
				                   	  </el-col>
				                   	  <el-col :span="6">
				                   	  	<el-form-item label="总费用" prop="total_cost">
				                   	  		<el-input v-model="editExpressForm.total_cost" placeholder="请输入总费用"></el-input>
				                   	  	</el-form-item>
				                   	  </el-col>
				                   	  <el-col :span="6">
				                   		  <el-form-item label="失效日" prop="valid_to">
				                   		  	 <el-date-picker
				                   		  	      v-model="editExpressForm.valid_to"
				                   		  	      type="datetime"
				                   		  	      placeholder="选择日期时间"
				                   		  	      default-time="00:00:00">
				                   		  	    </el-date-picker>
				                   		  </el-form-item>
				                   		  </el-col>
				                      </el-row>
									  
									  <el-row :gutter="20">
									   <el-col :span="6">
									   	<el-form-item label="网络类型" prop="cate">
									   		<el-input v-model="editExpressForm.cate" placeholder="请输入网络类型"></el-input>
									   	</el-form-item>
									   </el-col>
								
									
									   </el-row>
									  
									  
									  	</el-form>
									<span slot="footer" class="dialog-footer">
										<el-button @click="editExpressDialogVisible = false">取 消</el-button>
										<el-button type="primary" @click="editExpressInfo">确 定</el-button>
									</span>
								</el-dialog>
				
								<div class="wrapper-fcl">
									<div class="wrapper-fcl-item"></div>
									<span>预览</span>
								</div>
								<div class="ysbj">
									<div style="display: flex;flex-wrap: wrap;" v-if="tjExpressList.length>0">
										<div style="padding-top: 30px;padding: 15px;" v-for="item in tjExpressList" :key="item.id">
											<el-card class="box-card-list" shadow="always">
												<el-row type="flex" justify="end" style="margin-top: -15px;margin-bottom: 5px;">
													<i class="iconfont icon-bianji" style="margin-right: 10px;" @click="editExpressCard(item.id)"></i>
													<i class="iconfont icon-guanbi" @click="deteleExpressCard(item.id)"></i>
												</el-row>
											
												<div style="display: flex;justify-content: space-between;">
													
													<div style="display: flex;">
													<span>{{item.from}}</span>
													<i class="iconfont icon-jiantou"></i>
													<span>{{item.to}}</span>
													</div>
													
													<span>重量:{{item.weight}}</span>	
													
													
												</div>
												<div style="padding-top: 10px;display: flex;justify-content: space-between;">
													<span style="font-weight: bold;">标准价格:{{item.special_cost}}</span>
													<span style="color: green;font-weight: bold;">燃油费:{{item.fuel}}</span>
												</div>
												<div style="padding-top: 10px;display: flex;justify-content: space-between;">
													<span>折扣:{{item.discount}}</span>
													<span style="color: red;font-weight: bold;">总费用:{{item.total_cost}}</span>
												</div>
												<div style="padding-top: 10px;display: flex;justify-content: space-between;">
													<span>网络类型:{{item.cate}}</span>
													<span>失效日:{{item.valid_to}}</span>
												</div>
											</el-card>
										</div>
									</div>
									<div v-else><el-empty description="当前没有特惠航线"></el-empty></div>
				
								</div>
				
				
			</el-tab-pane>
			
			
			
			
			
			
			
			
			
			
		</el-tabs>
	</el-card>
</div>
</template>

<script>
	export default {
		data() {
			return {
				activeName: 'first',
				tjFclList: [],
				addDialogVisible: false,
				addForm: { 
            pol:'',
			pod:'',
			carrier:'',
			sale_state:'',
			['20GP']:'',
			['40GP']:'',
			['40HQ']:'',
			via:'',
			valid_to:''
				},
				addFormRules: {
                   pol:[
                   	{required:true,message:'请输入起运港',trigger:'blur'},
                   	// {min:1,max:5,message:'用户名的长度在1~5字符之间',trigger:'blur'}
                   ],
                   pod:[
                   	{required:true,message:'请输入目的港',trigger:'blur'},
                   ],
				   carrier:[
				   	{required:true,message:'请输入船公司',trigger:'blur'},
				   ],
				   sale_state:[
				   	{required:true,message:'请输入船期',trigger:'blur'},
				   ],
				   ['20GP']:[
				   	{required:true,message:'请输入20GP价格',trigger:'blur'},
				   ],
				   ['40GP']:[
				   	{required:true,message:'请输入40GP价格',trigger:'blur'},
				   ],
				   ['40HQ']:[
				   	{required:true,message:'请输入40HQ价格',trigger:'blur'},
				   ],
				   via:[
				   	{required:true,message:'请输入中转港',trigger:'blur'},
				   ],
				   valid_to:[
				   	{required:true,message:'请选择日期',trigger:'change'},
				   ],
				},
				editDialogVisible:false,
				editForm:{},
				editFormRules: {
				   pol:[
				   	{required:true,message:'请输入起运港',trigger:'blur'},
				   	// {min:1,max:5,message:'用户名的长度在1~5字符之间',trigger:'blur'}
				   ],
				   pod:[
				   	{required:true,message:'请输入目的港',trigger:'blur'},
				   ],
				   carrier:[
				   	{required:true,message:'请输入船公司',trigger:'blur'},
				   ],
				   sale_state:[
				   	{required:true,message:'请输入船期',trigger:'blur'},
				   ],
				   ['20GP']:[
				   	{required:true,message:'请输入20GP价格',trigger:'blur'},
				   ],
				   ['40GP']:[
				   	{required:true,message:'请输入40GP价格',trigger:'blur'},
				   ],
				   ['40HQ']:[
				   	{required:true,message:'请输入40HQ价格',trigger:'blur'},
				   ],
				   via:[
				   	{required:true,message:'请输入中转港',trigger:'blur'},
				   ],
				   valid_to:[
				   	{required:true,message:'请选择日期',trigger:'change'},
				   ],
				},
				//海运拼箱
				tjLclList:[],
				addLclDialogVisible:false,
				addLclForm:{
					pol:'',
					pod:'',
					country:'',
					volume:'',
					via:'',
					freight_cmb:'',
					freight_ton:'',
					t_t:'',
					etd:'',
					valid_to:''
					
				},
				addLclFormRules:{
					pol:[
						{required:true,message:'请输入起运港',trigger:'blur'},
					],
					pod:[
						{required:true,message:'请输入目的港',trigger:'blur'},
					],
					country:[
						{required:true,message:'请输入国家',trigger:'blur'},
					],
					volume:[
						{required:true,message:'请输入货量',trigger:'blur'},
					],
					freight_cmb:[
						{required:true,message:'请输入体积价',trigger:'blur'},
					],
					freight_ton:[
						{required:true,message:'请输入重量价',trigger:'blur'},
					],
					t_t:[
						{required:true,message:'请输入预计航程',trigger:'blur'},
					],
					etd:[
						{required:true,message:'请输入开航日',trigger:'blur'},
					],
					via:[
						{required:true,message:'请输入中转港',trigger:'blur'},
					],
					valid_to:[
						{required:true,message:'请选择日期',trigger:'change'},
					],
				},
				editLclDialogVisible:false,
				editLclForm:{},
				editLclFormRules:{
				pol:[
					{required:true,message:'请输入起运港',trigger:'blur'},
				],
				pod:[
					{required:true,message:'请输入目的港',trigger:'blur'},
				],
				country:[
					{required:true,message:'请输入国家',trigger:'blur'},
				],
				volume:[
					{required:true,message:'请输入货量',trigger:'blur'},
				],
				freight_cmb:[
					{required:true,message:'请输入体积价',trigger:'blur'},
				],
				freight_ton:[
					{required:true,message:'请输入重量价',trigger:'blur'},
				],
				t_t:[
					{required:true,message:'请输入预计航程',trigger:'blur'},
				],
				etd:[
					{required:true,message:'请输入开航日',trigger:'blur'},
				],
				via:[
					{required:true,message:'请输入中转港',trigger:'blur'},
				],
				valid_to:[
					{required:true,message:'请选择日期',trigger:'change'},
				],	
				},
				//内陆拖车
				tjTrailerList:[],
				addTrailerDialogVisible:false,
				addTrailerForm:{
					dock:'',
					trailer_door_point:'',
					['20GP']:'',
					['40GP']:'',
					['40HQ']:'',
					valid_to:''
				},
				addTrailerFormRules:{
					dock:[
						{required:true,message:'请输入港区',trigger:'blur'},
					],
					trailer_door_point:[
						{required:true,message:'请输入门点地址',trigger:'blur'},
					],
					['20GP']:[
						{required:true,message:'请输入20GP价格',trigger:'blur'},
					],
					['40GP']:[
						{required:true,message:'请输入40GP价格',trigger:'blur'},
					],
					['40HQ']:[
						{required:true,message:'请输入40HQ价格',trigger:'blur'},
					],
					valid_to:[
						{required:true,message:'请选择日期',trigger:'change'},
					],	
				},
				editTrailerDialogVisible:false,
				editTrailerForm:{},
				editTrailerFormRules:{
					dock:[
						{required:true,message:'请输入港区',trigger:'blur'},
					],
					trailer_door_point:[
						{required:true,message:'请输入门点地址',trigger:'blur'},
					],
					['20GP']:[
						{required:true,message:'请输入20GP价格',trigger:'blur'},
					],
					['40GP']:[
						{required:true,message:'请输入40GP价格',trigger:'blur'},
					],
					['40HQ']:[
						{required:true,message:'请输入40HQ价格',trigger:'blur'},
					],
					valid_to:[
						{required:true,message:'请选择日期',trigger:'change'},
					],
				},
				
				//空运
				tjByAirList:[],
				addByAirDialogVisible:false,
				addByAirForm:{
					pol:'',
					pod:'',
					country:'',
					etd:'',
					carrier:'',
					via:'',
					valid_fm:''
					
				},
				addByAirFormRules:{
					pol:[
						{required:true,message:'请输入起运港',trigger:'blur'},
					],
					pod:[
						{required:true,message:'请输入目的港',trigger:'blur'},
					],
					country:[
						{required:true,message:'请输入国家',trigger:'blur'},
					],
					etd:[
						{required:true,message:'请输入航班日期',trigger:'blur'},
					],
					carrier:[
						{required:true,message:'请输入航空公司',trigger:'blur'},
					],
					t_t:[
						{required:true,message:'请输入预计时效',trigger:'blur'},
					],
					via:[
						{required:true,message:'请输入中转港',trigger:'blur'},
					],
					valid_fm:[
						{required:true,message:'请选择失效日',trigger:'change'},
					],
				},
				editByAirForm:{},
				editByAirDialogVisible:false,
				editByAirFormRules:{
				pol:[
					{required:true,message:'请输入起运港',trigger:'blur'},
				],
				pod:[
					{required:true,message:'请输入目的港',trigger:'blur'},
				],
				country:[
					{required:true,message:'请输入国家',trigger:'blur'},
				],
				etd:[
					{required:true,message:'请输入航班日期',trigger:'blur'},
				],
				carrier:[
					{required:true,message:'请输入航空公司',trigger:'blur'},
				],
				t_t:[
					{required:true,message:'请输入预计时效',trigger:'blur'},
				],
				via:[
					{required:true,message:'请输入中转港',trigger:'blur'},
				],
				valid_fm:[
					{required:true,message:'请选择失效日',trigger:'change'},
				],	
				},
				
				//铁路
				tjrailroadList:[],
				addrailroadDialogVisible:false,
				addrailroadForm:{
					pol:'',
					pod:'',
					['40_coc']:'',
					['40_soc']:'',
					['20_coc']:'',
					['20_soc']:'',
					['2_20soc']:'',
					currency:'',
					squad:'',
					t_t:'',
					valid_to:''
				},
				addrailroadFormRules:{
					pol:[
						{required:true,message:'请输入起运港',trigger:'blur'},
					],
					pod:[
						{required:true,message:'请输入目的港',trigger:'blur'},
					],
					['40_coc']:[
						{required:true,message:'请输入40coc价格',trigger:'blur'},
					],
					['40_soc']:[
						{required:true,message:'请输入40soc价格',trigger:'blur'},
					],
					['20_coc']:[
						{required:true,message:'请输入20coc价格',trigger:'blur'},
					],
					['20_soc']:[
						{required:true,message:'请输入20soc价格',trigger:'blur'},
					],
					['2_20soc']:[
						{required:true,message:'请输入2*20soc价格',trigger:'blur'},
					],
					currency:[
						{required:true,message:'请输入币种',trigger:'blur'},
					],
					squad:[
						{required:true,message:'请输入班列',trigger:'blur'},
					],
					t_t:[
						{required:true,message:'请输入预计航程',trigger:'blur'},
					],
					valid_to:[
						{required:true,message:'请选择日期',trigger:'change'},
					],	
				},
				editrailroadDialogVisible:false,
				editrailroadForm:{},
				editrailroadFormRules:{
					pol:[
						{required:true,message:'请输入起运港',trigger:'blur'},
					],
					pod:[
						{required:true,message:'请输入目的港',trigger:'blur'},
					],
					['40_coc']:[
						{required:true,message:'请输入40coc价格',trigger:'blur'},
					],
					['40_soc']:[
						{required:true,message:'请输入40soc价格',trigger:'blur'},
					],
					['20_coc']:[
						{required:true,message:'请输入20coc价格',trigger:'blur'},
					],
					['20_soc']:[
						{required:true,message:'请输入20soc价格',trigger:'blur'},
					],
					['2_20soc']:[
						{required:true,message:'请输入2*20soc价格',trigger:'blur'},
					],
					currency:[
						{required:true,message:'请输入币种',trigger:'blur'},
					],
					squad:[
						{required:true,message:'请输入班列',trigger:'blur'},
					],
					t_t:[
						{required:true,message:'请输入预计航程',trigger:'blur'},
					],
					valid_to:[
						{required:true,message:'请选择日期',trigger:'change'},
					],
				},
				
				
				//国际快递
				tjExpressList:[],
				addExpressDialogVisible:false,
				addExpressForm:{
					from:'',
					to:'',
					weight:'',
					special_cost:'',
					fuel:'',
					discount:'',
					total_cost:'',
					valid_to:'',
					cate:'',
				},
				addExpressFormRules:{
					from:[
						{required:true,message:'请输入起始地',trigger:'blur'},
					],
					to:[
						{required:true,message:'请输入目的地',trigger:'blur'},
					],
					weight:[
						{required:true,message:'请输入重量',trigger:'blur'},
					],
					fuel:[
						{required:true,message:'请输入燃油费',trigger:'blur'},
					],
					special_cost:[
						{required:true,message:'请输入标准价格',trigger:'blur'},
					],
					total_cost:[
						{required:true,message:'请输入总费用',trigger:'blur'},
					],
					valid_to:[
						{required:true,message:'请选择日期',trigger:'change'},
					],	
					cate:[
						{required:true,message:'请输入网络类型',trigger:'blur'},
					],
				},
				editExpressDialogVisible:false,
				editExpressForm:{},
				editExpressFormRules:{
					from:[
						{required:true,message:'请输入起始地',trigger:'blur'},
					],
					to:[
						{required:true,message:'请输入目的地',trigger:'blur'},
					],
					weight:[
						{required:true,message:'请输入重量',trigger:'blur'},
					],
					fuel:[
						{required:true,message:'请输入燃油费',trigger:'blur'},
					],
					special_cost:[
						{required:true,message:'请输入标准价格',trigger:'blur'},
					],
					total_cost:[
						{required:true,message:'请输入总费用',trigger:'blur'},
					],
					valid_to:[
						{required:true,message:'请选择日期',trigger:'change'},
					],
					cate:[
						{required:true,message:'请输入网络类型',trigger:'blur'},
					],
				},
				
				
			}
		},
		computed:{
		},
		created() {
			this.getFclList()
			
		},
		methods: {
			handleClick(tab, event) {
			if(this.activeName =='second'){
				  this.getLclList()
			}else if(this.activeName =='five'){
				this.getTrailerList()
			}else if(this.activeName =='third'){
				this.getByAirList()
			}else if(this.activeName =='four'){
				this.getRailroadList()
			}else if(this.activeName =='six'){
				this.getExpressList()
			}		
			},
			//*********海运整箱**************
			async getFclList(){
				const {data:res} = await this.$http.getSpecialFclSaleList()
				if (res.status !==0){
			     return this.$message.error('获取列表失败!')
				}
				this.tjFclList = res.data
			},
			//新增海运整箱
			addBtnFn() {
				this.addDialogVisible = true
			},
			addDialogClosed() {
				this.$refs.addFormRef.resetFields()
			},
			saveAddFclInfo() {
				console.log(this.addForm)
				this.$refs.addFormRef.validate(async valid =>{
					if (valid){
						const { data: res } = await this.$http.saveSpecialFclSale(this.addForm)
						if (res.status !== 0 ){
						return this.$message.error('新增失败！')
						}
						this.addDialogVisible = false
						this.getFclList()
						}else{
							return false
						}
						})
			},
		async editFclCard(id){
				const {data:res} = await this.$http.byIdSpecialFclSale(id)
				if (res.status !==0){
					return this.$message.error('查询信息失败!')
				}
				this.editForm = res.data
				this.editDialogVisible = true
			},
			editFclInfo(){
				this.$refs.editFormRef.validate(async valid =>{
					if (valid){
						const {data:res} = await this.$http.editSpecialFclSale(this.editForm)
							if (res.status !==0){
								return this.$message.error('修改失败!')
							}
							this.$message.success('修改成功!')
							this.editDialogVisible = false
							this.getFclList()
				
					}else{
						return false
					}
				
				})
			},
			editDialogClosed(){
				this.$refs.editFormRef.resetFields()
			},
			async deteleFclCard(id){
				const confirmResult = await this.$confirm('是否删除该卡片特惠航线, 是否继续?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  lockScroll:false,
				  type: 'warning'
				}).catch(err => err)
				//如果用户确认删除，则返回值为字符串 confirm
				console.log(confirmResult)
				if (confirmResult !== 'confirm'){
					return this.$message.info('已取消删除')
				}
				const {data:res} = await this.$http.delSpecialFclSale(id)
				if (res.status !==0){
					return this.$message.error('删除失败!')
				}
				this.$message.success('删除成功!')
				this.getFclList()
			},
			
			
			//*********海运拼箱**************
			
			async getLclList(){
				const {data:res} = await this.$http.getSpecialLclSaleList()
				if (res.status !==0){
			     return this.$message.error('获取列表失败!')
				}
				this.tjLclList = res.data
			},
			addLclBtnFn(){
			this.addLclDialogVisible = true	
			},
			saveAddLclInfo(){
				this.$refs.addLclFormRef.validate(async valid =>{
					if (valid){
						const { data: res } = await this.$http.saveSpecialLclSale(this.addLclForm)
						if (res.status !== 0 ){
						return this.$message.error('新增失败！')
						}
						this.addLclDialogVisible = false
						this.getLclList()
						}else{
							return false
						}
						})
			},
			
			
			addLclDialogClosed(){
				this.$refs.addLclFormRef.resetFields()
			},
		async editLclCard(id){
			const {data:res} = await this.$http.byIdSpecialLclSale(id)
			if (res.status !==0){
				return this.$message.error('查询信息失败!')
			}
			this.editLclForm = res.data
            this.editLclDialogVisible = true
			},
			editLclInfo(){
				this.$refs.editLclFormRef.validate(async valid =>{
					if (valid){
						const {data:res} = await this.$http.editSpecialLclSale(this.editLclForm)
							if (res.status !==0){
								return this.$message.error('修改失败!')
							}
							this.$message.success('修改成功!')
							this.editLclDialogVisible = false
							this.getLclList()
				
					}else{
						return false
					}
				
				})
			},
			editLclDialogClosed(){
				this.$refs.editLclFormRef.resetFields()
			},
			async deteleLclCard(id){
				
				const confirmResult = await this.$confirm('是否删除该卡片特惠航线, 是否继续?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  lockScroll:false,
				  type: 'warning'
				}).catch(err => err)
				//如果用户确认删除，则返回值为字符串 confirm
				console.log(confirmResult)
				if (confirmResult !== 'confirm'){
					return this.$message.info('已取消删除')
				}
				const {data:res} = await this.$http.delSpecialLclSale(id)
				if (res.status !==0){
					return this.$message.error('删除失败!')
				}
				this.$message.success('删除成功!')
				this.getLclList()
				
			},
				//*********内陆拖车**************
				async getTrailerList(){
					const {data:res} = await this.$http.getSpecialTrailerSaleList()
					if (res.status !==0){
				     return this.$message.error('获取列表失败!')
					}
					this.tjTrailerList = res.data
				},
				addTrailerBtnFn(){
				this.addTrailerDialogVisible = true	
				},
				saveAddTrailerInfo(){
					this.$refs.addTrailerFormRef.validate(async valid =>{
						if (valid){
							const { data: res } = await this.$http.saveSpecialTrailerSale(this.addTrailerForm)
							if (res.status !== 0 ){
							return this.$message.error('新增失败！')
							}
							this.addTrailerDialogVisible = false
							this.getTrailerList()
							}else{
								return false
							}
							})
				},
			    addTrailerDialogClosed(){
				this.$refs.addTrailerFormRef.resetFields()	
				},
			async editTrailerCard(id){
					const {data:res} = await this.$http.byIdSpecialTrailerSale(id)
					if (res.status !==0){
						return this.$message.error('查询信息失败!')
					}
					this.editTrailerForm = res.data
					this.editTrailerDialogVisible = true
				},
				editTrailerInfo(){
				this.$refs.editTrailerFormRef.validate(async valid =>{
					if (valid){
						const {data:res} = await this.$http.editSpecialTrailerSale(this.editTrailerForm)
							if (res.status !==0){
								return this.$message.error('修改失败!')
							}
							this.$message.success('修改成功!')
							this.editTrailerDialogVisible = false
							this.getTrailerList()
				
					}else{
						return false
					}
				
				})	
				},
				editTrailerDialogClosed(){
					this.$refs.editTrailerFormRef.resetFields()	
				},
			async deteleTrailerCard(id){
				const confirmResult = await this.$confirm('是否删除该卡片特惠航线, 是否继续?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  lockScroll:false,
				  type: 'warning'
				}).catch(err => err)
				//如果用户确认删除，则返回值为字符串 confirm
				console.log(confirmResult)
				if (confirmResult !== 'confirm'){
					return this.$message.info('已取消删除')
				}
				const {data:res} = await this.$http.delSpecialTrailerSale(id)
				if (res.status !==0){
					return this.$message.error('删除失败!')
				}
				this.$message.success('删除成功!')
				this.getTrailerList()	
				},
				
				//********************空运************************
				async getByAirList(){
					const {data:res} = await this.$http.getSpecialByAirSaleList()
					if (res.status !==0){
				     return this.$message.error('获取列表失败!')
					}
					this.tjByAirList = res.data
				},
				addByAirBtnFn(){
				this.addByAirDialogVisible = true	
				},
				saveAddByAirInfo(){
					this.$refs.addByAirFormRef.validate(async valid =>{
						if (valid){
							const { data: res } = await this.$http.saveSpecialByAirSale(this.addByAirForm)
							if (res.status !== 0 ){
							return this.$message.error('新增失败！')
							}
							this.addByAirDialogVisible = false
							this.getByAirList()
							}else{
								return false
							}
							})
				},
				addByAirDialogClosed(){
					this.$refs.addByAirFormRef.resetFields()	
				},
				async editByAirCard(id){
					const {data:res} = await this.$http.byIdSpecialByAirSale(id)
					if (res.status !==0){
						return this.$message.error('查询信息失败!')
					}
					this.editByAirForm = res.data
					this.editByAirDialogVisible = true
				},
				editByAirInfo(){
					this.$refs.editByAirFormRef.validate(async valid =>{
						if (valid){
							const {data:res} = await this.$http.editSpecialByAirSale(this.editByAirForm)
								if (res.status !==0){
									return this.$message.error('修改失败!')
								}
								this.$message.success('修改成功!')
								this.editByAirDialogVisible = false
								this.getByAirList()
					
						}else{
							return false
						}
					
					})	
				},
				editByAirDialogClosed(){
					this.$refs.editByAirFormRef.resetFields()	
				},
				async deteleByAirCard(id){
					const confirmResult = await this.$confirm('是否删除该卡片特惠航线, 是否继续?', '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					  lockScroll:false,
					  type: 'warning'
					}).catch(err => err)
					//如果用户确认删除，则返回值为字符串 confirm
					console.log(confirmResult)
					if (confirmResult !== 'confirm'){
						return this.$message.info('已取消删除')
					}
					const {data:res} = await this.$http.delSpecialByAirSale(id)
					if (res.status !==0){
						return this.$message.error('删除失败!')
					}
					this.$message.success('删除成功!')
					this.getByAirList()	
				},
				
				//********************铁路************************
				async getRailroadList(){
					const {data:res} = await this.$http.getSpecialRailRoadSaleList()
					if (res.status !==0){
				     return this.$message.error('获取列表失败!')
					}
					this.tjrailroadList = res.data
				},
				addrailroadBtnFn(){
				this.addrailroadDialogVisible = true	
				},
				saveAddrailroadInfo(){
					this.$refs.addrailroadFormRef.validate(async valid =>{
						if (valid){
							const { data: res } = await this.$http.saveSpecialRailRoadSale(this.addrailroadForm)
							if (res.status !== 0 ){
							return this.$message.error('新增失败！')
							}
							this.addrailroadDialogVisible = false
							this.getRailroadList()
							}else{
								return false
							}
							})
				},
				addrailroadDialogClosed(){
					this.$refs.addrailroadFormRef.resetFields()	
				},
				async editRailroadCard(id){
					const {data:res} = await this.$http.byIdSpecialRailRoadSale(id)
					if (res.status !==0){
						return this.$message.error('查询信息失败!')
					}
					this.editrailroadForm = res.data
					this.editrailroadDialogVisible = true
				},
				editrailroadInfo(){
					this.$refs.editrailroadFormRef.validate(async valid =>{
						if (valid){
							const {data:res} = await this.$http.editSpecialRailRoadSale(this.editrailroadForm)
								if (res.status !==0){
									return this.$message.error('修改失败!')
								}
								this.$message.success('修改成功!')
								this.editrailroadDialogVisible = false
								this.getRailroadList()
					
						}else{
							return false
						}
					
					})	
				},
				editrailroadDialogClosed(){
					this.$refs.editrailroadFormRules.resetFields()	
				},
				async deteleRailroadCard(id){
					const confirmResult = await this.$confirm('是否删除该卡片特惠航线, 是否继续?', '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消',
					  lockScroll:false,
					  type: 'warning'
					}).catch(err => err)
					//如果用户确认删除，则返回值为字符串 confirm
					console.log(confirmResult)
					if (confirmResult !== 'confirm'){
						return this.$message.info('已取消删除')
					}
					const {data:res} = await this.$http.delSpecialRailRoadSale(id)
					if (res.status !==0){
						return this.$message.error('删除失败!')
					}
					this.$message.success('删除成功!')
					this.getRailroadList()
				},
				
			//********************国际铁路************************
			async getExpressList(){
				const {data:res} = await this.$http.getSpecialExpressSaleList()
				if (res.status !==0){
			     return this.$message.error('获取列表失败!')
				}
				this.tjExpressList = res.data
			},
			addExpressBtnFn(){
			this.addExpressDialogVisible = true	
			},
			saveAddExpressInfo(){
				this.$refs.addExpressFormRef.validate(async valid =>{
					if (valid){
						const { data: res } = await this.$http.saveSpecialExpressSale(this.addExpressForm)
						if (res.status !== 0 ){
						return this.$message.error('新增失败！')
						}
						this.addExpressDialogVisible = false
						this.getExpressList()
						}else{
							return false
						}
						})
			},
			addExpressDialogClosed(){
				this.$refs.addExpressFormRef.resetFields()	
			},
			async editExpressCard(id){
				const {data:res} = await this.$http.byIdSpecialExpressSale(id)
				if (res.status !==0){
					return this.$message.error('查询信息失败!')
				}
				this.editExpressForm = res.data
				this.editExpressDialogVisible = true
			},
			editExpressInfo(){
				this.$refs.editExpressFormRef.validate(async valid =>{
					if (valid){
						const {data:res} = await this.$http.editSpecialExpressSale(this.editExpressForm)
							if (res.status !==0){
								return this.$message.error('修改失败!')
							}
							this.$message.success('修改成功!')
							this.editExpressDialogVisible = false
							this.getExpressList()
				
					}else{
						return false
					}
				
				})	
			},
			editExpressDialogClosed(){
				this.$refs.editExpressFormRef.resetFields()	
			},
			async deteleExpressCard(id){
				const confirmResult = await this.$confirm('是否删除该卡片特惠航线, 是否继续?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  lockScroll:false,
				  type: 'warning'
				}).catch(err => err)
				//如果用户确认删除，则返回值为字符串 confirm
				console.log(confirmResult)
				if (confirmResult !== 'confirm'){
					return this.$message.info('已取消删除')
				}
				const {data:res} = await this.$http.delSpecialExpressSale(id)
				if (res.status !==0){
					return this.$message.error('删除失败!')
				}
				this.$message.success('删除成功!')
				this.getExpressList()
			}
				
				
				
		}
	}
</script>

<style lang="scss" scoped>
	@import url(//at.alicdn.com/t/c/font_4358597_mx5fnrmv26.css);
@media screen and (min-width: 1280px) {
		.wrapperddiv{
			height: 100vh;
			width: 100%;
			display:inline-block;
		} 
	}
	
	//手机端
	@media screen and (max-width: 1280px) {
		.wrapperddiv{
			height: 100%;
			width: 100%;
			display:inline-block;
		} 
	}
	.ysbj {
		top: 50%;
		left: 50%;
		position: relative;
		width: 1200px;
		min-width: 1200px;
		// height: 100%;
		// min-height: 800px;
		// height: 800px;
		transform: translate(-50%);
	}

	.box-card {
		//height: 900px;
		width: 100%;
	}

	.box-card-list {
		width: 350px;
		height: 150px;
		box-shadow: 3px 3px 3px 3px rgba(0, 0, 0, 0.15) !important;

	}

	.wrapper-fcl {
		display: flex;
		margin-top: 30px;
	}

	.wrapper-fcl-item {
		height: 18px;
		width: 8px;
		background: rgb(24, 144, 255);
		margin-right: 5px;
	}

	// .formItem{
	// display: flex;
	// justify-content: space-between;	
	// }
</style>